export default __webpack_public_path__ + "static/media/Logo-with-image.f78848ab.png";